import React, { useState, useEffect, useMemo } from "react";
import {
  getAllAdmin,
  cleanAll,
  setBelogs,
  setDone,
} from "../../store/reducers/todosReducer";
import { toast } from "react-toastify";
import FilledLoading from "../common/loader/FilledLoading";
import OpacityLoading from "../common/loader/OpacityLoading";
import { useSelector, useDispatch } from "react-redux";
import ClientRoutes from "../../navigation/Routes";
import {
  FlexRowBetween,
  FlexRowStart,
  GenericDiv,
  ListHolder,
  TextWithPic,
  TodoCard,
} from "../common/Style";
import ToolsOptions from "../user/ToolsOptions";
import GenericModal from "../common/modals/GenericModal";
import { useHistory } from "react-router-dom";
import LogoutSpecipic from "../common/LogOut/LogoutSpecipic";
import tools from "../../assets/common/menu.svg";
import logout from "../../assets/common/logout.svg";
import sms from "../../assets/common/sms.svg";
import whatsapp from "../../assets/common/whatsapp.svg";
import refresh from "../../assets/common/refresh.svg";
import BottomMenu from "../common/others/BottomMenu";
import Switcher from "../common/switcher/Switcher";
import { days } from "../common/others/Functions";
import {
  countNotAnswered,
  deleteMsgs,
  getMsgs,
  getPhoneNumber,
  sendSms,
  sendWhatsapp,
} from "../../store/reducers/dataReducer";
import CopyText from "../common/others/CopyText";
import OptionalGuests2 from "./OptionalGuests2";
import { findByPhones } from "../../store/reducers/guestsReducer";

const dict = {
  הודעה: "ac",
  ווצאפ: "ac",
  שיחה: "ac",
  קדם: "kdam",
  תזכורת: "reminder",
  תודה: "thank",
  ערב: "evening",
};

const Msgs = () => {
  const dispatch = useDispatch();
  const [showLoading, setShowLoading] = useState(false);
  const { dataLoading, data } = useSelector((state) => state.dataReducer);
  let history = useHistory();
  const [showLogout, setShowLogout] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const [showOptionalGuests, setShowOptionalGuests] = useState(false);

  const handleGetAll = () => {
    setShowLoading(true);
    dispatch(getMsgs()).then((res) => {
      if (res.payload?.error) toast.error(res.payload?.error);
      setShowLoading(false);
    });
  };

  const handleEdit = (key, body) => {
    dispatch(findByPhones(key, body)).then((res) => {
      if (!res.payload?.error) {
        toast.success("הפעולה בוצעה בהצלחה");
      } else toast.error(res.payload?.error);
    });
  };

  const handleDeleteMsgs = (id) => {
    setShowLoading(true);
    dispatch(deleteMsgs({ id })).then((res) => {
      if (res.payload?.error) toast.error(res.payload?.error);
      setShowLoading(false);
    });
  };

  useEffect(() => {
    handleGetAll();
    return () => {
      dispatch(cleanAll());
    };
  }, []);

  let todosArray = useMemo(() => {
    let arr = [];
    if (Object.keys(data).length > 0) {
      for (const [key, value] of Object.entries(data))
        arr.push(
          <TodoCard key={key}>
            <div style={{ width: "100%" }}>
              <div>{`${value.platform}) ${value.msg}`}</div>
              <FlexRowStart>
                <div
                  onClick={() => handleDeleteMsgs(key)}
                  style={{
                    marginTop: "10px",
                    border: "2px solid silver",
                    width: "min-content",
                    padding: "5px 12px",
                  }}
                >
                  מחיקה
                </div>
                <div
                  onClick={() => setShowOptionalGuests(value.guestPhone)}
                  style={{
                    marginTop: "10px",
                    marginRight: "20px",
                    border: "2px solid silver",
                    width: "min-content",
                    padding: "5px 12px",
                  }}
                >
                  חפש
                </div>
              </FlexRowStart>
              <FlexRowBetween style={{ marginTop: "20px" }}>
                <div
                  style={{ padding: "4px 8px", border: "2px solid silver" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleEdit(`${value.guestPhone}-${value.userPhone}`, {
                      accept: parseInt(0),
                      ans: value.platform == true ? "W" : "M",
                      notes: "טעות במספר",
                    });
                  }}
                >
                  טעות
                </div>
                <div
                  style={{ padding: "4px 8px", border: "2px solid silver" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleEdit(`${value.guestPhone}-${value.userPhone}`, {
                      accept: parseInt(0),
                      ans: value.platform == true ? "W" : "M",
                    });
                  }}
                >
                  0
                </div>
                <div
                  style={{ padding: "4px 8px", border: "2px solid silver" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleEdit(`${value.guestPhone}-${value.userPhone}`, {
                      accept: parseInt(1),
                      ans: value.platform == true ? "W" : "M",
                    });
                  }}
                >
                  1
                </div>
                <div
                  style={{ padding: "4px 8px", border: "2px solid silver" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleEdit(`${value.guestPhone}-${value.userPhone}`, {
                      accept: parseInt(2),
                      ans: value.platform == true ? "W" : "M",
                    });
                  }}
                >
                  2
                </div>
              </FlexRowBetween>
            </div>
            <div>
              <CopyText
                marginLeft={"5px"}
                dataToCopy={value.userPhone}
                text={value.userPhone}
              />
              <CopyText
                marginLeft={"5px"}
                dataToCopy={value.guestPhone}
                text={value.guestPhone}
              />
              {/* <div>{value.userPhone}</div> */}
              {/* <div>{value.guestPhone}</div> */}
            </div>
          </TodoCard>
        );
    }
    return arr;
  }, [data]);

  return (
    <div
      style={{
        width: "100%",
        height: `${window.screen.availHeight}px`,
      }}
    >
      <BottomMenu
        data={[
          <img
            key={1}
            src={refresh}
            alt="refresh"
            style={{ width: "23px", padding: "10px 0", cursor: "pointer" }}
            onClick={handleGetAll}
          />,
          <img
            key={2}
            src={tools}
            alt="tools"
            style={{ width: "31px", padding: "10px 0", cursor: "pointer" }}
            onClick={() => setShowMenu(true)}
          />,
          <img
            key={3}
            src={logout}
            alt="logout"
            style={{ width: "31px", padding: "10px 0", cursor: "pointer" }}
            onClick={() => setShowLogout(true)}
          />,
        ]}
      />
      <ListHolder>{todosArray}</ListHolder>
      <div style={{ height: "100px" }} />

      {showLoading && <FilledLoading />}
      {dataLoading && <OpacityLoading />}
      {showLogout && (
        <GenericModal
          init={setShowLogout}
          div={<LogoutSpecipic init={setShowLogout} />}
        />
      )}

      {showOptionalGuests && (
        <GenericModal
          init={setShowOptionalGuests}
          div={<OptionalGuests2 phone={showOptionalGuests} />}
        />
      )}

      {showMenu && (
        <GenericModal
          init={setShowMenu}
          div={
            <ToolsOptions
              data={[
                <TextWithPic
                  key={1}
                  onClick={() => history.push(ClientRoutes.Admin.main)}
                >
                  ראשי
                </TextWithPic>,
                // <TextWithPic
                //   onClick={() => history.push(ClientRoutes.Admin.todos)}
                //   key={2}
                // >
                //   משימות
                // </TextWithPic>,
              ]}
            />
          }
        />
      )}
    </div>
  );
};

export default Msgs;
